'use client'

import { usePathname } from 'next/navigation'

export default function GlobalNotFound () {
  const pathname = usePathname()
  const locale = pathname?.startsWith('/en') ? 'en' : 'de'
  const redirectUrl = `/${locale}`

  return (
    <html lang={locale} translate='no'>
      <head>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <title>Redirecting...</title>
        <meta httpEquiv='refresh' content={`0;url=${redirectUrl}`} />
      </head>
      <body />
    </html>
  )
}
